<template>
  <div id="School-edit">

    <Modal v-model="modal.visible" :title="modal.title" footer-hide :mask-closable="false">
      <IForm ref="formInline" :key="modal.visible" :model="edit" :elem="kindergartenElem" :rules="kindergartenRule" :loading="loading.form"
             :btn-loading="loading.btn" :width="450" :label-width="120" button button-text="取消" @on-submit="handleSubmit"
             @on-click="modal.visible = false">

        <div slot="extend">
          <FormItem :label-width="120" label="幼儿园名称" prop="name">
            <Input v-model="edit.name" type="text" placeholder="请输入幼儿园名称" style="font-size: 25px;"/>
          </FormItem>
          <FormItem :label-width="120" label="联系地址" prop="address">
            <Input v-model="edit.address" type="text" placeholder="请输入联系地址" style="font-size: 25px;"/>
          </FormItem>
          <FormItem :label-width="120" label="联系电话" prop="phone">
            <Input v-model="edit.phone" type="text" placeholder="请输入联系电话" style="font-size: 25px;"/>
          </FormItem>
          <FormItem :label-width="120" label="状态" prop="status">
            <Select v-model="edit.status">
              <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </div>
      </IForm>

    </Modal>
  </div>
</template>
<script>
import {_edit} from "@/services/manage/kindergartens";
export default {
  name: "ClassesEdit",
  data() {
    return {
      modal: {
        title: "",
        visible: false
      },
      edit: {
        name: "",
        subordinate: "",
        address: "",
        phone: "",
        status: 1,
      },
      init: "",
      statusList:[
        {
          label: "启用",
          value: 1
        }, {
          label: "禁用",
          value: 2
        }
      ],
      loading: {
        form: false,
        btn: false
      },
      kindergartenElem: [],
      kindergartenRule: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "幼儿园名称不能为空"
          }
        ],
        /*subordinate: [
          {
            required: false,
            trigger: "blur",
            message: "下级名称不能为空"
          }
        ],
        */
        phone: [
          {
            required: false,
            trigger: "blur",
            message: "联系电话不能为空"
          }
        ],
        address: [
          {
            required: false,
            trigger: "blur",
            message: "联系地址不能为空"
          }
        ],
        status: [
          {
            required: true,
            trigger: "blur",
            message: "状态不能为空",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(title, row) {
      this.modal = {
        title: title,
        visible: true
      };

      this.loading.form = true;
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.loading.form = false
    },
    handleEdit(row) {
      const edit = Object.assign({}, row);
      this.edit = {...edit};
      if (this.edit) {
        this.loading.form = false
      }
    },
    handleSubmit() {

      this.$Loading.start();
      this.loading.btn = true;
      const payload = this.edit;
      _edit(payload)
        .then(res => {
          if (res.errcode === 1){
            this.$message.success(res.errmsg);
            this.$emit("on-update");
          } else{
            this.$message.error(res.errmsg);
          }
          this.$Loading.finish();
          this.loading.btn = false;
          this.modal.visible = false;
        }).catch(() => {
        this.$Loading.error();
        this.loading.btn = false;
        this.modal.visible = false;
      });
    },
  },
};
</script>
<style lang="postcss" scoped>

</style>
